import { render, staticRenderFns } from "./eg_table_base.vue?vue&type=template&id=0baf6558&scoped=true&"
import script from "./eg_table_base.vue?vue&type=script&lang=js&"
export * from "./eg_table_base.vue?vue&type=script&lang=js&"
import style0 from "./eg_table_base.vue?vue&type=style&index=0&id=0baf6558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf6558",
  null
  
)

export default component.exports